<template>
  <div>
    <div class="grid bg-white" v-if="!isReadOnlyUser">
      <div class="grid-title">
        <h1 class="float-left">Shelf Scan</h1>
      </div>
      <div class="grid-body">
        <div class="row">
          <form @submit.prevent="submit()">
            <div class="col-md-12">
              <input
                type="text"
                v-model="barcode"
                class="form-control scan-shirt"
              />
            </div>
            <div class="col-md-12">
              <br />
              <button type="submit" class="btn btn-lg btn-block btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="grid-body text-center">
        <h2 class="text-bold message text-capitalize" v-html="message"></h2>
        <br /><br />
      </div>
    </div>
    <div class="grid bg-white" v-else>
      <div class="grid-body">
        <h4>
          You don't have the privilege to do this action, please contact an
          administrator.
        </h4>
      </div>
    </div>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isReadOnlyUser: false,
      message: "",
      barcode: null,
      approved: 0,
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    $(".scan-shirt").focus();
  },
  methods: {
    submit() {
      this.scanShelf(this.barcode);
    },

    async askForApproval(barcode) {
      const { value: password } = await Swal.fire({
        title: "Packaging already done!",
        text: "Enter approval password to scan",
        input: "password",
        inputPlaceholder: "****",
        inputValidator: (value) => {
          if (!value) {
            return "Required Password";
          }
        },
      });
      if (password) {
        if (password == "8899") {
          this.approved = 1;
          this.scanShelf(barcode);
        } else {
          this.askForApproval(barcode);
        }
      }
    },

    async scanShelf(barcode) {
      $(".loading").show();
      try {
        let res = await axios.post("packaging/shelf/scan", {
          barcode: barcode,
          approved: this.approved,
        });
        if (res.data.success === true) {
          let boxNumber = res.data.box_number;
          this.message = '';
          if(typeof boxNumber === 'object' && !Array.isArray(boxNumber) && boxNumber !== null) {
            for (const [itemId, number] of Object.entries(boxNumber)) {
              this.message += "Item #" + itemId + " into " + number.replace(/_/g, " ") + "<br/>";
            }
          } else {
            this.message = barcode + " into " + res.data.box_number.replace(/_/g, " ");
          }

          $(".loading").hide();
          this.barcode = null;
        }
      } catch (error) {
        $(".loading").hide();
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.message = barcode;
          let message = error.response.data.message;
          if (message === "approval_required") {
            this.askForApproval(barcode);
          } else {
            Swal.fire({
              title: "ERROR",
              text: message,
              type: "warning",
            });
          }
        }
        this.barcode = null;
      }
    },
  },
};
</script>

<style scoped>
.scan-shirt {
  font-size: 90px !important;
  height: 200px;
}
.btn-lg {
  height: 50px;
  font-size: 25px;
}
.loading {
  font-size: 150px;
  position: absolute;
  top: 20%;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
}
.message {
  font-size: 70px;
  line-height: 70px;
}
</style>
